function respawnMe(elementRef, api) {
  // delay for weird UI behaviour
  setTimeout(() => {
    api.restart(elementRef.current.uuid, elementRef.current.userData.origin)
    elementRef.current.userData = { ...elementRef.current.userData, freeze: false }
    elementRef.current.position.y = 0;
  }, 100);
}
export default respawnMe
